import * as React from "react";
import { TradingAccountResources, StreamUpdate, SwanPublicClient, Currency } from "swan-public-api-client";
import { SubscriptionLifecycle } from "../Push/SubscriptionLifecycle";
import { AppState } from "../Store/RootReducer";
import { connect } from "react-redux";

interface PropsFromState {
  currencies: Map<string, Currency>;
}

interface OwnProps {
  groupKey: string;
  children: (currency?: Currency, tradingAccountResources?: TradingAccountResources) => JSX.Element;
}

interface Props extends PropsFromState, OwnProps {}

interface State {
  tradingAccountResources?: TradingAccountResources;
}

class StreamingTradingAccountResourcesCmp extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      tradingAccountResources: undefined
    };
  }

  public componentDidUpdate(prevProps: Props) {
    if (prevProps.groupKey !== this.props.groupKey) {
      const state: State = {
        tradingAccountResources: undefined
      };

      this.setState(state);
    }
  }

  public render() {
    const papiSubscribe = (client: SwanPublicClient, groupKey: string) => {
      return client.streamTradingAccountResources(groupKey, this.consumeUpdate, undefined);
    };
    return <SubscriptionLifecycle papiSubscribe={papiSubscribe} groupKey={this.props.groupKey}>
      {() => {
        const currencyKey = this.state.tradingAccountResources?.CurrencyId.toString();
        const currency = currencyKey !== undefined ? this.props.currencies.get(currencyKey) : undefined;
        return this.props.children(currency, this.state.tradingAccountResources);
      }}
    </SubscriptionLifecycle>
  }

  private consumeUpdate = (newData: Array<StreamUpdate<TradingAccountResources>>) => {
    const data = newData[0];
    this.setState({
      tradingAccountResources: data.update
    });
  }
}

const mapStateToProps = (state: AppState, ownProps: OwnProps): PropsFromState => ({
  currencies: new Map(state.tradingAccounts.concat(state.linkedTradingAccounts).find(x => x.Key === ownProps.groupKey)!.Currencies.map(x => [x.Key, x]))
});

export const StreamingTradingAccountResources = connect(mapStateToProps)(
  StreamingTradingAccountResourcesCmp
);